module.exports = __webpack_public_path__ + "img/DW365-168.aa45adbc.jpg";